import { Theme, createStyles, getColor } from '@bb-ui/react-library';

export const styles = (theme: Theme) =>
  createStyles({
    root: {
      position: 'fixed',
      width: '100%',
      height: '100%',
      display: 'grid',
      justifyContent: 'center',
      alignContent: 'center',
      backgroundColor: getColor('background.default', theme),
      color: getColor('text.primary', theme),
    },
  });
